<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <b-row class="align-items-center my-2">
          <b-col cols=12 md=4 class='my-2'>
            Start
          </b-col>
          <b-col cols=12 md=8>
            <b-form inline>
              <b-form-input v-if="!!startDate" type=date v-model="startDate" :disabled=enabled />
              <b-form-input v-if="!!startTime" type=time v-model="startTime" :disabled=enabled />
            </b-form>
          </b-col>
          <b-col cols=12 md=4 class='my-2'>
            Product Number(s)
          </b-col>
          <b-col cols=12 md=8>
            <b-form-input v-model="product" :disabled=enabled />
          </b-col>
          <b-col cols=1>
            <b-form-checkbox switch v-model=endpointChecked :disabled=enabled>{{endpoint}}</b-form-checkbox>
          </b-col>
          <b-col class='text-right mt-2'>
            <b-button variant="danger" v-if="enabled" @click="stopTicking()">Stop & Reset</b-button>
            <b-button variant="success" v-else @click="startTicking()" disabled title="This might not be entirely functional yet">Start Live Update</b-button>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols=12 sm=5>
        <b-row>
          <b-col>
            <table class="table table-striped mt-2">
              <thead>
                <tr>
                  <th>Counter</th>
                  <th v-for="p in products" :key="p">{{p}}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Sold</td>
                  <td v-for="p in products" :key="p">{{soldCount(p)}}</td>
                </tr>
                <tr>
                  <td>Quoted</td>
                  <td v-for="p in products" :key="p">{{quoteCount(p)}}</td>
                </tr>
                <tr>
                  <td>Canceled</td>
                  <td v-for="p in products" :key="p">{{canceledCount(p)}}</td>
                </tr>
                <tr>
                  <td>Total Sold</td>
                  <td v-for="p in products" :key="p">{{totalSoldCount(p)}}</td>
                </tr>
                <tr>
                  <td>Web Inventory</td>
                  <td v-for="p in products" :key="p">{{inventoryData[p] ? inventoryData[p] : '-'}}</td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-row class="bg-primary text-white mx-2">
          <b-col>Order</b-col>
          <b-col>Status</b-col>
          <b-col>Quantity</b-col>
          <b-col>Placed At</b-col>
        </b-row>
        <div style="max-height: 80vh; overflow-y: none; overflow-x: none;">
          <b-row v-for="order, i in relevantOrders" :key="i" class="align-items-center">
            <b-col>
              <router-link :to="`/sales-order/view/${order.num}`">{{order.num}}</router-link>
            </b-col>
            <b-col>
              <web-status :websiteOrder="order" />
            </b-col>
            <b-col>
              <b-row v-for="product in products" :key="product"
                v-if="order.items.filter((i) => {return (i.sku == product)}).map((i) => {return i.quantity}).reduce((a,v) => a+v, 0) != 0">
                {{product}}: {{order.items.filter((i) => {return (i.sku == product)}).map((i) => {return i.quantity}).reduce((a,v) => a+v, 0)}}
              </b-row>
            </b-col>
            <b-col>
              <NiceDate :value="order.placed_at" />
            </b-col>
          </b-row>
        </div>
      </b-col>
      <b-col cols="6">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Counter</th>
              <th v-for="p in products" :key="p">{{p}}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Sold</td>
              <td v-for="p in products" :key="p">
                {{relevantOrders.filter( o => !o.quote && !o.canceled_at ).map(o => o.items.filter( i => i.sku == p).map(i => i.quantity).reduce((a,v) => a+v, 0)).reduce( (a,v) => a+v, 0)}}
              </td>
            </tr>
            <tr>
              <td>Quoted</td>
              <td v-for="p in products" :key="p">
                {{relevantOrders.filter( o => o.quote ).map(o => o.items.filter( i => i.sku == p).map(i => i.quantity).reduce((a,v) => a+v, 0)).reduce( (a,v) => a+v, 0)}}
              </td>
            </tr>
            <tr>
              <td>Canceled</td>
              <td v-for="p in products" :key="p">
                {{-relevantOrders.filter( o => o.canceled_at ).map(o => o.items.filter( i => i.sku == p).map(i => i.quantity).reduce((a,v) => a+v, 0)).reduce( (a,v) => a+v, 0)}}
              </td>
            </tr>
            <tr>
              <td>Total Sold</td>
              <td v-for="p in products" :key="p">
                {{relevantOrders.filter( o => !o.quote && !o.canceled_at ).map(o => o.items.filter( i => i.sku == p).map(i => i.quantity).reduce((a,v) => a+v, 0)).reduce( (a,v) => a+v, 0)+relevantOrders.filter( o => o.quote ).map(o => o.items.filter( i => i.sku == p).map(i => i.quantity).reduce((a,v) => a+v, 0)).reduce( (a,v) => a+v, 0)-relevantOrders.filter( o => o.canceled_at ).map(o => o.items.filter( i => i.sku == p).map(i => i.quantity).reduce((a,v) => a+v, 0)).reduce( (a,v) => a+v, 0)}}
              </td>
            </tr>
            <tr>
              <td>Web Inventory</td>
              <td v-for="p in products" :key="p">
                {{inventoryData[p] && enabled ? inventoryData[p].available : '-'}}
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>


    <b-modal id="statusModal" ref="statusModalRef" centered hide-header hide-footer>
      <center>
        <fingerprint-spinner :animation-duration="1500" :size="300" color="#293a93" class="my-3" />
      </center>
    </b-modal>
  </b-container>
</template>

<script>
import axios from 'axios';
import NiceDate from '../utility/NiceDate'
import WebStatus from '../sales-order/view-order-2/WebStatus.vue';
import { FingerprintSpinner } from 'epic-spinners';
import moment from 'moment';

const BASE_API = process.env.VUE_API_ROOT;

export default {
  components: {
    NiceDate,
    FingerprintSpinner,
    WebStatus,
  },
  data() {
    return {
      startDate: moment().format("YYYY-MM-DD"),
      startTime: moment().format("HH:mm:SS"),
      product: 'am-6515',
      enabled: false,
      spinning: false,
      ticker: null,
      orderIds: [],
      rawOrders: [],
      endpointChecked: false,
      endpoints: { false: 'workarea', true: 'shopify' },
      startingInventory: 0,
      inventoryData: {},
    }
  },
  methods: {
    resetOrders() {
      this.rawOrders = [];
      this.orderIds = []
      this.inventoryData = {}
    },
    updateOrders() {
      let promise = undefined
      if (this.endpoint === 'workarea') {
        promise = axios({
          method: 'post',
          headers: { 'Content-Type': 'text/plain' },
          url: `${BASE_API}/workarea/orders/after-date`,
          data: { placed_at_greater_than: this.oldestOrder },
        })
      } else if (this.endpoint === 'shopify') {
        promise = axios({
          method: 'post',
          headers: { 'Content-Type': 'text/plain' },
          url: `${BASE_API}/shopify/orders/after-date`,
          data: { date: `${this.startDate}T${this.startTime}` },
        })
      } else {
        console.warn('????')
      }

      if (typeof(promise) === 'undefined') return
      promise.then(async (r) => {
        let newIds = r.data.filter(x => !this.orderIds.includes(x))
        this.orderIds = this.orderIds.concat(newIds)
        await axios.all(newIds.map(id => axios.get((`${BASE_API}/bridge/${id}`)))).then(responses => {
          responses.forEach(order => {
            this.rawOrders.push(order.data.web)
          })
        })
        this.hideSpinner()
      })
    },
    updateInventory() {
      if (this.endpoint === 'workarea') {
        this.products.forEach(p => {
          axios.get(`${BASE_API}/workarea/inventory/${p}`).then(r => {
            this.$set(this.inventoryData, p, JSON.parse(r.data).inventory_sku.available)
          })
        })
      } else if (this.endpoint == 'shopify') {
        this.products.forEach(p => {
          axios.get(`${BASE_API}/shopify/inventory/${p}`).then(r => {
            this.$set(this.inventoryData, p, JSON.parse(r.data))
          })
        })
      } else {
        console.warn('????')
      }
    },
    showSpinner() {
      this.spinning = true
      this.$refs.statusModalRef.show();
    },
    hideSpinner() {
      this.$refs.statusModalRef.hide();
      this.spinning = false
    },
    intersection(a,b) {
      return a.filter(x => b.includes(x)).length > 0
    },
    startTicking() {
      this.showSpinner()
      this.enabled = true

      this.updateOrders()
      this.updateInventory()
      if (!this.ticker) {
        this.ticker = setInterval(() => {
          if (this.enabled) {
            this.updateOrders()
            this.updateInventory()
          }
        }, 15000)
      }
    },
    stopTicking() {
      this.resetOrders()
      this.enabled = false
      clearInterval(this.ticker)
    },
    soldCount(p) {
      return this.sumGroupQty(this.relevantOrders.filter(o => !o.quote && !o.canceledAt), p)
    },
    quoteCount(p) {
      return this.sumGroupQty(this.relevantOrders.filter(o => o.quote), p)
    },
    canceledCount(p) {
      return -1 * this.sumGroupQty(this.relevantOrders.filter(o => o.canceledAt), p)
    },
    totalSoldCount(p) {
      return this.soldCount(p) + this.quoteCount(p) - this.canceledCount(p)
    },
    sumGroupQty(group, p) {
      return group.map(o => {
        return o.items.filter(i => i.sku == p).map(i => i.qty).reduce((a,v) => a+v, 0)
      }).reduce((a,v) => a+v, 0)
    },
  },
  computed: {
    endpoint() {
      return this.endpoints[this.endpointChecked]
    },
    products() {
      return this.product.split(',').map(e => e.trim())
    },
    relevantOrders() {
      if (!this.rawOrders) return []
      return this.rawOrders.filter(o => o && o.items && this.intersection(o.items.map(i => i.sku), this.products))
    },
    oldestOrder() {
      if (this.relevantOrders) {
        let x = this.relevantOrders.map(o => o.placedAt).sort().reverse()[0]
        if (x) return x.slice(0,16).replace(/T/g, ' ')
      }
      return `${this.startDate}T${this.startTime}`
    },
  },
  beforeDestroy() {
    clearInterval(this.ticker);
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ops-info/InventoryWatcher.vue